import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Paper,
  IconButton,
} from '@mui/material';
import {
  Close as CloseIcon,
  Receipt as ReceiptIcon,
  Description as DescriptionIcon,
  Visibility as VisibilityIcon,
  Print as PrintIcon,
} from '@mui/icons-material';

const PrintOptionsDialog = ({ 
  open, 
  onClose, 
  onSelectFormat,
  container, // ✅ Add this
  style, // ✅ Add this
}) => {
  const [selectedFormat, setSelectedFormat] = useState('receipt');

  const handlePreview = () => {
    onSelectFormat(selectedFormat, 'preview');
  };

  const handlePrint = () => {
    onSelectFormat(selectedFormat, 'print');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      container={container} // ✅ Now defined
      disablePortal={!!container} // ✅ Now defined
      style={style} // ✅ Now defined
      sx={{
        position: container ? 'absolute' : undefined,
        zIndex: container ? 2000 : undefined,
      }}
      BackdropProps={{
        sx: {
          position: container ? 'absolute' : undefined,
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pb: 1,
      }}>
        <Typography variant="h6" fontWeight={600}>
          Choose Print Format
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            value={selectedFormat}
            onChange={(e) => setSelectedFormat(e.target.value)}
          >
            {/* Thermal Receipt Option */}
            <Paper
              elevation={selectedFormat === 'receipt' ? 3 : 0}
              sx={{
                p: 2,
                mb: 2,
                border: '2px solid',
                borderColor: selectedFormat === 'receipt' ? 'primary.main' : 'grey.200',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                  borderColor: 'primary.main',
                  transform: 'translateY(-2px)',
                },
              }}
              onClick={() => setSelectedFormat('receipt')}
            >
              <FormControlLabel
                value="receipt"
                control={<Radio />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                    <ReceiptIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        Ticket de Caisse
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Thermal receipt format (80mm) - Fast printing for POS
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        • Compact layout • Quick print • Thermal printer compatible
                      </Typography>
                    </Box>
                  </Box>
                }
                sx={{ m: 0, width: '100%' }}
              />
            </Paper>

            {/* A4 Invoice Option */}
            <Paper
              elevation={selectedFormat === 'a4' ? 3 : 0}
              sx={{
                p: 2,
                border: '2px solid',
                borderColor: selectedFormat === 'a4' ? 'primary.main' : 'grey.200',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                  borderColor: 'primary.main',
                  transform: 'translateY(-2px)',
                },
              }}
              onClick={() => setSelectedFormat('a4')}
            >
              <FormControlLabel
                value="a4"
                control={<Radio />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                    <DescriptionIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        A4 Invoice
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Professional A4 format - Detailed invoice layout
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        • Professional design • Full details • Standard printer
                      </Typography>
                    </Box>
                  </Box>
                }
                sx={{ m: 0, width: '100%' }}
              />
            </Paper>
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ p: 2.5, pt: 1, gap: 1 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{ minWidth: 100 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handlePreview}
          variant="outlined"
          startIcon={<VisibilityIcon />}
          sx={{ minWidth: 120 }}
        >
          Preview
        </Button>
        <Button
          onClick={handlePrint}
          variant="contained"
          startIcon={<PrintIcon />}
          sx={{ minWidth: 120 }}
        >
          Print
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrintOptionsDialog;